(()=>{
  const mq=window.matchMedia('(min-width:901px)');

  const initRoot=root=>{
    if(!root||root.dataset.akDesktopDockReady==='true')return;
    root.dataset.akDesktopDockReady='true';

    const productStrip=root.querySelector('.ak-hero-products');
    const detailWrap=root.querySelector('.ak-hero-detail-wrap');
    if(!productStrip||!detailWrap)return;

    const dock=document.createElement('div');
    dock.className='ak-desktop-purchase-dock';
    dock.setAttribute('aria-label','Purchase selected jerky');
    productStrip.insertAdjacentElement('afterend',dock);

    const restoreDockAction=()=>{
      const current=dock.querySelector('.ak-home-product-actions');
      if(current&&current.__akDesktopDockOwner){
        current.__akDesktopDockOwner.appendChild(current);
      }
    };

    const sync=()=>{
      const active=detailWrap.querySelector('.ak-hero-detail.is-active');
      if(!mq.matches){
        restoreDockAction();
        return;
      }
      if(!active)return;

      const current=dock.querySelector('.ak-home-product-actions');
      if(current&&current.__akDesktopDockOwner!==active){
        if(current.__akDesktopDockOwner)current.__akDesktopDockOwner.appendChild(current);
      }

      let actions=active.querySelector('.ak-home-product-actions');
      const dockCurrent=dock.querySelector('.ak-home-product-actions');
      if(!actions&&dockCurrent&&dockCurrent.__akDesktopDockOwner===active)actions=dockCurrent;
      if(!actions)return;

      actions.__akDesktopDockOwner=active;
      if(actions.parentElement!==dock)dock.appendChild(actions);
    };

    let raf=0;
    const queueSync=()=>{
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(sync);
    };

    const observer=new MutationObserver(mutations=>{
      if(mutations.some(m=>m.type==='childList'||(m.type==='attributes'&&m.attributeName==='class')))queueSync();
    });
    observer.observe(detailWrap,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});

    if(mq.addEventListener)mq.addEventListener('change',queueSync);
    else mq.addListener(queueSync);

    window.addEventListener('pageshow',queueSync);
    queueSync();
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-hero-focus]').forEach(initRoot);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
